import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import Events from '../hooks/events';

const AssignDataToDictionaryTable = ({ dictionaries, filterValue }) => {
  const updateProperties = Events.useUpdateActiveDictionaryAttachmentProperties();
  return (
    <Table celled striped className={clsx(dictionaries.length > 0 ? 'selectable' : 'border-0')}>
      <Table.Body className={clsx(dictionaries.length > 4 && 'overflow-scroll h-250 db')}>
        {dictionaries.map(({ name }) => (
          <Table.Row className={clsx('db', name === filterValue && 'active')} key={`convert_dictionary_${name}`}>
            <Table.Cell className="w-100 db relative">
              <i title="Dictionary" aria-hidden="true" className="book icon primary mt-n5" />
              {name}
              <button
                type="button"
                className="w-100 absolute top-0 left-0 h-100p pointer border-0 bg-transparent"
                aria-label="click to filter"
                onClick={() => { updateProperties({ properties: { filter: name } }); }}
              />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default AssignDataToDictionaryTable;
